var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoctorPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 92,
    viewBox: "0 0 96 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_6",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 8,
    width: 83,
    height: 83
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.26 78.26C92.3241 62.1959 92.3241 36.1508 76.26 20.0867C60.1958 4.02257 34.1508 4.02257 18.0867 20.0867C2.02254 36.1508 2.02254 62.1959 18.0867 78.26C34.1508 94.3241 60.1958 94.3241 76.26 78.26Z",
    fill: "#E5E2FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.1626 77.1618C96.6816 59.6428 96.6816 31.239 79.1626 13.72C61.6437 -3.79891 33.2398 -3.79891 15.7209 13.72C-1.79808 31.239 -1.79808 59.6428 15.7209 77.1618C33.2398 94.6807 61.6437 94.6807 79.1626 77.1618Z",
    fill: "#EAE8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 82H22.5V84L29 88L43 92.5L66.5 89L72 82Z",
    fill: "#9783FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5856 52.9576V57.4262C57.7257 58.0745 58.8657 58.6466 59.9258 59.2115V66.7692C58.2957 67.0951 57.0758 68.5581 57.0758 70.2637C57.0758 72.2953 58.7059 73.9212 60.6592 73.9212C62.6125 73.9212 64.2426 72.2953 64.2426 70.2637C64.2426 68.7211 63.266 67.4174 61.7992 66.9321C61.8791 66.8525 61.8791 66.7692 61.8791 66.6895V60.1096C75.2398 66.2839 82 64.5783 82 83.9993H13C13 63.4412 20.087 66.2839 34.0177 59.704V62.793C29.454 63.3615 25.8706 67.182 25.8706 71.8933V80.4251C25.8706 80.9936 26.3571 81.4028 26.8472 81.4028H30.1039C30.594 81.4028 31.0805 80.9972 31.0805 80.4251C31.0805 79.8529 30.5904 79.4509 30.1039 79.4509H27.8238V71.8933C27.8238 67.8302 31.164 64.5819 35.2376 64.5819C39.3111 64.5819 42.5714 67.8302 42.5714 71.8933V79.4509H40.5346C39.9646 79.4509 39.558 79.8565 39.558 80.4251C39.558 80.9936 39.9646 81.4028 40.5346 81.4028H43.5481C44.1181 81.4028 44.5247 80.9972 44.5247 80.4251V71.8933C44.5247 67.019 40.698 63.1189 35.971 62.7133V58.7335C36.7842 58.3279 37.6011 57.9187 38.3309 57.4335V53.5334C35.3973 51.5018 34.7474 47.6814 33.6873 43.7812C33.2008 43.7812 32.874 43.0497 32.874 42.2386V41.9126C32.6308 41.4238 32.304 40.8552 32.0608 39.8811C31.734 38.744 30.6739 36.3069 31.6541 35.2495C32.4674 34.4383 33.041 35.2495 33.041 35.2495C31.8175 28.8325 30.191 20.4601 39.0679 17.9433C39.0679 12.4172 59.9222 14.8544 62.4491 23.712C63.5891 27.1233 62.1223 35.1698 62.1223 35.1698C62.3656 34.6013 62.7722 34.5216 63.2624 34.7642C64.4024 35.5754 63.1788 38.8273 62.8521 39.8811C62.6088 40.9385 62.2821 41.5867 61.959 41.9959V42.2386C61.959 43.0497 61.6322 43.7016 61.2256 43.7812C60.3288 47.2758 59.3522 51.1759 56.582 52.9612L56.5856 52.9576ZM60.6592 71.973C59.6826 71.973 58.9492 71.2415 58.9492 70.2673C58.9492 69.3729 59.6826 68.6414 60.6592 68.6414C61.556 68.6414 62.3692 69.3729 62.3692 70.2673C62.3692 71.2415 61.556 71.973 60.6592 71.973Z",
    fill: "#9783FC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorPlaceholder);
export default __webpack_public_path__ + "static/media/doctor-placeholder.88378592bda4563e310fd4501a1a2d17.svg";
export { ForwardRef as ReactComponent };